var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlaytn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 227.22 227.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\uBB34\\uC81C_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_21",
    "data-name": "\\uBB34\\uC81C \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 21",
    x1: 70.65,
    y1: 94.51,
    x2: 197.38,
    y2: -32.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ff3f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ff6700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ff8c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\uBB34\\uC81C_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_68",
    "data-name": "\\uBB34\\uC81C \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 68",
    x1: 177.65,
    y1: 177.97,
    x2: 177.65,
    y2: 32.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f00048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ff8c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\uBB34\\uC81C_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_30",
    "data-name": "\\uBB34\\uC81C \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 30",
    x1: -0.52,
    y1: 159.29,
    x2: 115.23,
    y2: 43.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#850000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#a90e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ce1c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e92700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f92d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ff2f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\uBB34\\uC81C_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_62",
    "data-name": "\\uBB34\\uC81C \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 62",
    x1: 52.79,
    y1: 221.49,
    x2: 161.96,
    y2: 158.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#850000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#d30168"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.41,26.28A113.15,113.15,0,0,0,117.63,0L59.69,153Z",
    style: {
      fill: "url(#\uBB34\uC81C_\uADF8\uB77C\uB514\uC5B8\uD2B8_21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.86,40.76l-72.78,72.78,72.77,72.77A113.62,113.62,0,0,0,200.86,40.76Z",
    style: {
      fill: "url(#\uBB34\uC81C_\uADF8\uB77C\uB514\uC5B8\uD2B8_68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.15,17.47.22,106.39a113.42,113.42,0,0,0,25.34,79Z",
    style: {
      fill: "url(#\uBB34\uC81C_\uADF8\uB77C\uB514\uC5B8\uD2B8_30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.62,128,40.84,200.79a113.64,113.64,0,0,0,145.55,0Z",
    style: {
      fill: "url(#\uBB34\uC81C_\uADF8\uB77C\uB514\uC5B8\uD2B8_62)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaytn);
export default __webpack_public_path__ + "static/media/klaytn.106404fc426fcb492f4a124ef12a2451.svg";
export { ForwardRef as ReactComponent };